/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';

const messages = defineMessages({
  title: {id: 'navigation.students.scheduling.course-recommendations'},
});

const CourseRecommendationsItem = () => (
  <RouteLinkItem
    route="midas/students/scheduling/course-recommendations"
    title={messages.title}
  />
);

export default CourseRecommendationsItem;
